import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {TenantService} from '../authentication/tenant.service';

@Component({
  selector: 'app-tng-redirect',
  templateUrl: './tng-redirect.component.html'
})
export class TngRedirectComponent {

  url: string;

  constructor(public dialogRef: MatDialogRef<TngRedirectComponent>, private matDialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: { tenantId: string }, private tenantService: TenantService) {
    tenantService.getTenantById(data.tenantId).subscribe(t => {
      this.url = 'https://' + t.domains[0] + '/tng';
      window.location.href = this.url;
    });
    const disabled = window.location.pathname.includes('invitation');
    dialogRef.beforeClosed().subscribe(c => {
      if (c === undefined && !disabled) {
        matDialog.open(TngRedirectComponent, {data});
      }
    });
    if (disabled) {
      dialogRef.close();
    }

  }

}
